/* ABD Hybrid Bundle Recommendations v7: saved per-product metafields are always preferred.
   Shopify's native related recommendations provide automatic add-ons; a narrow shared
   collection is the fallback. No third-party app or client-side checkout discounts. */
(() => {
  'use strict';
  const cleanProduct = (p) => {
    if (!p || !p.id) return null;
    const variant = Array.isArray(p.variants) ? p.variants[0] : null;
    const variantId = Number(p.variantId || (variant && variant.id));
    const variantsCount = p.variantsCount == null ? (p.variants || []).length : Number(p.variantsCount);
    const available = Boolean(p.available) && (variant ? Boolean(variant.available) : true);
    const imageValue = p.image || p.featured_image || (p.images && p.images[0]);
    const image = typeof imageValue === 'string' ? imageValue : imageValue && (imageValue.src || imageValue.url);
    const price = Number(p.price == null && variant ? variant.price : p.price);
    return {
      id: Number(p.id), variantId, variantsCount, available,
      title: String(p.title || ''), type: String(p.product_type || p.type || ''),
      price, image: image ? String(image) : '',
      url: String(p.url || (p.handle ? '/products/' + encodeURIComponent(p.handle) : ''))
    };
  };
  const valid = p => p && Number.isSafeInteger(p.id) && Number.isSafeInteger(p.variantId)
    && Number.isFinite(p.price) && p.price >= 0 && p.available && p.variantsCount === 1;
  const append = (parent, name, className, value) => {
    const el = document.createElement(name);
    if (className) el.className = className;
    if (value != null) el.textContent = String(value);
    parent.appendChild(el);
    return el;
  };
  function setup(root) {
    if (root.dataset.autoEnabled !== 'true' || root.dataset.abdAutoInit === 'true') return;
    const el = root.querySelector('[data-abd-auto-data]');
    if (!el) return;
    let cfg;
    try { cfg = JSON.parse(el.textContent); } catch (e) { return; }
    const main = cleanProduct(cfg.main);
    if (!valid(main)) return;
    root.dataset.abdAutoInit = 'true';
    const status = root.querySelector('[data-abd-auto-status]');
    const money = cents => {
      const amount = Number(cents) / 100;
      try { return new Intl.NumberFormat(cfg.locale || document.documentElement.lang || 'en-US', {
        style:'currency', currency: cfg.currency || 'USD'
      }).format(amount); }
      catch(e) { return '$' + amount.toFixed(2); }
    };
    function allValid(items, used) {
      return items.length === 2 && items.every(p => valid(p) && !used.has(p.id)) && items[0].id !== items[1].id;
    }
    function renderItem(grid, p, primary) {
      const node = append(grid, 'span', 'abd-bundle__product');
      node.title = p.title;
      const thumb = append(node, 'span', 'abd-bundle__thumb');
      if (p.image) {
        const img = append(thumb, 'img');
        img.loading = 'lazy'; img.alt = p.title; img.src = p.image;
        img.width = 90; img.height = 90;
      } else append(thumb, 'span', 'abd-bundle__placeholder', '▧');
      append(node, 'span', 'abd-bundle__name', p.title);
      append(node, 'span', 'abd-bundle__item-price', primary ? 'This pattern' : money(p.price));
    }
    function renderTier(products, size) {
      const fieldset = root.querySelector('.abd-bundle__offers');
      if (!fieldset || products.length !== size || root.querySelector(`.abd-bundle__radio[value="${size}"]`)) return false;
      const total = products.reduce((sum, p) => sum + p.price, 0);
      const discount = Number(size === 3 ? cfg.discount3 : cfg.discount5);
      const discounted = Math.round(total * (100 - discount) / 100);
      const shown = cfg.showDiscounts ? discounted : total;
      const tier = document.createElement('label');
      tier.className = 'abd-bundle__tier abd-bundle__tier--expanded';
      const radio = append(tier, 'input', 'abd-bundle__radio');
      radio.type = 'radio';
      radio.name = root.querySelector('.abd-bundle__radio').name;
      radio.value = String(size);
      radio.dataset.ids = products.map(p=>p.variantId).join(',');
      radio.dataset.price = money(shown);
      radio.dataset.compare = cfg.showDiscounts ? money(total) : '';
      const badge = append(tier, 'span', 'abd-bundle__badge' + (size === 5 ? ' abd-bundle__badge--best' : ''), size === 3 ? cfg.label3 : cfg.label5);
      const header = append(tier, 'span', 'abd-bundle__head');
      const dot = append(header, 'span', 'abd-bundle__dot'); dot.setAttribute('aria-hidden','true');
      const title = append(header, 'span', 'abd-bundle__title', `${size} Patterns` + (cfg.showDiscounts ? ` - Save ${discount}%` : ''));
      if (cfg.showDiscounts) {
        append(title, 'small', '', `You saved ${money(total-discounted)} · ${money(Math.round(discounted/size))} per pattern`);
      }
      const price = append(header, 'span', 'abd-bundle__price');
      append(price, 'strong', '', money(shown));
      if (cfg.showDiscounts) append(price, 's', '', money(total));
      const grid = append(tier, 'span', 'abd-bundle__grid');
      grid.style.setProperty('--abd-count', String(size));
      products.forEach((p,i) => renderItem(grid,p,i===0));
      if (size === 3) {
        const five = fieldset.querySelector('.abd-bundle__radio[value="5"]');
        const fiveLabel = five && five.closest('.abd-bundle__tier');
        if (fiveLabel) fieldset.insertBefore(tier, fiveLabel);
        else fieldset.appendChild(tier);
      } else fieldset.appendChild(tier);
      return true;
    }
    const uniqueCandidates = (suggestions, source, seen) => {
      source.forEach(raw => {
        const p = cleanProduct(raw);
        if (!valid(p) || seen.has(p.id) || p.id === main.id) return;
        if (cfg.excludeBundles && /\bbundles?\b/i.test(p.title + ' ' + p.type)) return;
        suggestions.push(p); seen.add(p.id);
      });
    };
    const recommendationsUrl = () => {
      const url = new URL('recommendations/products.json', window.location.origin + (window.Shopify?.routes?.root || '/'));
      url.searchParams.set('product_id', String(cfg.productId));
      url.searchParams.set('limit','10');
      url.searchParams.set('intent','related');
      return url.toString();
    };
    async function fill() {
      const manual3 = (cfg.manual3 || []).map(cleanProduct);
      const manual5 = (cfg.manual5 || []).map(cleanProduct);
      const manual3Good = allValid(manual3, new Set([main.id]));
      const base = manual3Good ? manual3 : [];
      const manual5Good = allValid(manual5, new Set([main.id, ...base.map(p=>p.id)]));
      const suggestions = [];
      const seen = new Set([main.id, ...manual3.filter(valid).map(p=>p.id), ...manual5.filter(valid).map(p=>p.id)]);
      try {
        const response = await fetch(recommendationsUrl(), {credentials:'same-origin'});
        if (response.ok) {
          const json = await response.json();
          uniqueCandidates(suggestions, Array.isArray(json.products) ? json.products : [], seen);
        }
      } catch (e) { /* Collection recommendations remain available when API is unavailable */ }
      uniqueCandidates(suggestions, cfg.fallback || [], seen);
      // Make manual overrides authoritative even when automatic suggestions are available.
      const selected3 = manual3Good ? manual3 : suggestions.splice(0,2);
      // Do not show a 5-pack unless the 3-pack can also be displayed.
      if (selected3.length !== 2) {
        if (status) status.textContent = 'Not enough available related patterns for an automatic bundle. Choose add-ons manually.';
        return;
      }
      const manualIds = new Set([main.id,...selected3.map(p=>p.id)]);
      const selected5 = manual5Good && allValid(manual5, manualIds) ? manual5 : suggestions.filter(p=>!manualIds.has(p.id)).slice(0,2);
      const added3 = renderTier([main,...selected3],3);
      const added5 = selected5.length === 2 ? renderTier([main,...selected3,...selected5],5) : false;
      // The theme's existing listeners stay in place; notify them of newly inserted radios.
      if (added3 || added5) {
        const preferred = String(cfg.defaultTier);
        const target = root.querySelector(`.abd-bundle__radio[value="${preferred}"]`)
          || root.querySelector('.abd-bundle__radio[value="3"]');
        if (target && preferred !== '1') target.checked = true;
        root.dispatchEvent(new CustomEvent('abd:auto-ready'));
        const note = root.querySelector('.abd-bundle__note');
        if (note) note.hidden = true;
      }
      if (status) status.textContent = `${root.querySelector('.abd-bundle__radio[value="3"]') ? '3-pattern bundle ready' : '3-pattern bundle unavailable'}; ${root.querySelector('.abd-bundle__radio[value="5"]') ? '5-pattern bundle ready' : '5-pattern bundle unavailable'}. Manual product choices take priority.`;
    }
    fill();
  }
  function scan() { document.querySelectorAll('[data-abd-bundles]').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',scan);
  else scan();
  document.addEventListener('shopify:section:load',scan);
})();
